const navBarLinksData=[
    {
        label:'Overview',
        path:'/overview',
        icon: 'OverviewIcon'
    },
    {
        label:'Print',
        path:'/print',
        icon:'PrintIcon'
    },
    {
        label:'Digital',
        path:'/digital',
        icon:'DigitalIcon'
    },
    {
        label:'TV',
        path:'/tv',
        icon:'TVIcon'
    },
    {
        label:'Radio',
        path:'/radio',
        icon:'RadioIcon'
    },
    {
        label:'Published',
        path:'/content',
        icon: 'ContentIcon'
    },
    {
        label:'Geography',
        path:'/demographics',
        icon:'DemographicsIcon'
    },
]
export default navBarLinksData;